import React, { useState } from "react";
import { motion } from "framer-motion";
// import {
//   GoogleMap,
//   useLoadScript,
//   Marker,
//   InfoWindow,
// } from "@react-google-maps/api";

import "./css/DetailsModal.scss";
import mapStyles from "../mapStyles";

import { X } from "react-feather";

// const libraries = ["places"];
// const googleMapsApiKey = ["AIzaSyDZyUtlD-3zzsRYYKkvGG47BdS8diMrbUg"];

// const mapContainerStyle = {
//   width: "100%",
//   height: "100%",
// };

import HospitalBanner from "../assets/images/img-hospital-location.png";

const DetailsModal = ({ setIsModalActive, props }) => {
  // const { isLoaded, loadError } = useLoadScript({
  //   // googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  //   googleMapsApiKey: "AIzaSyDZyUtlD-3zzsRYYKkvGG47BdS8diMrbUg",
  //   libraries,
  // });

  const [markers, setMarkers] = useState([]);

  // if (loadError) return "Error loading maps";
  // if (!isLoaded) return "Loading Maps.";

  const center = {
    lat: props.latitude === "" ? 0 : parseInt(props.latitude),
    lng: props.longitude === "" ? 0 : parseInt(props.longitude),
  };

  console.log(center);

  const options = {
    styles: mapStyles,
  };

  function copyTextToClipBoard(target) {
    target.focus();
    target.select();
    document.execCommand("copy");
    document.activeElement.blur();
  }

  const modalInnerVariants = {
    initial: {
      y: -10,
      opacity: 0,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
      },
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0.3,
      },
    },
    exit: {
      y: 10,
      opacity: 0,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
      },
    },
  };

  return (
    <motion.div
      className='details-modal'
      key={props.providercode}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.3,
      }}
    >
      <motion.div
        className='modal-inner'
        variants={modalInnerVariants}
        initial='initial'
        animate='animate'
        exit='exit'
      >
        <div className='maps-container'>
          <iframe
            width='100%'
            height='100%'
            frameBorder={0}
            style={options.mapStyles}
            src={`https://www.google.com/maps/embed/v1/place?key=${"AIzaSyDZyUtlD-3zzsRYYKkvGG47BdS8diMrbUg"}&q=${props.providername
              .replace(" ", "+")
              .replace("&", "AND")}`}
            allowFullScreen
          ></iframe>
        </div>
        <div className='details-container'>
          <X
            className='btn-close'
            onClick={() => setIsModalActive(false)}
            style={{ zIndex: 1 }}
          />
          <div
            className='details-inner'
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <div className='title-container'>
              <h1>{props.providername}</h1>
              <div>{props.streetaddress}</div>
              <div>{props.provincename}</div>
              <img src={HospitalBanner} alt='hospital-location-banner' />
            </div>
            <div className='inputs-container'>
              <div className='label'>Contact Details</div>
              <input
                type='text'
                className='detail-input'
                value={props.telephone}
                readOnly={true}
                onClick={(e) => copyTextToClipBoard(e.currentTarget)}
              />
              <div className='label'>Coordinator</div>
              <input
                type='text'
                className='detail-input'
                value={props.coordinator === "" ? "N/A" : props.coordinator}
                readOnly={true}
                onClick={(e) => copyTextToClipBoard(e.currentTarget)}
              />
              <div className='label'>Coordinator Room</div>
              <input
                type='text'
                className='detail-input'
                value={
                  props.coordinatorroom === "" ? "N/A" : props.coordinatorroom
                }
                readOnly={true}
                onClick={(e) => copyTextToClipBoard(e.currentTarget)}
              />
              <div className='label'>Coordinator Schedule</div>
              <input
                type='text'
                className='detail-input'
                value={
                  props.coordinatorschedule === ""
                    ? "N/A"
                    : props.coordinatorschedule
                }
                readOnly={true}
                onClick={(e) => copyTextToClipBoard(e.currentTarget)}
              />
              <div className='label'>Website</div>
              <input
                type='text'
                className='detail-input'
                value={props.website === "" ? "N/A" : props.website}
                readOnly={true}
                onClick={(e) => copyTextToClipBoard(e.currentTarget)}
              />
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DetailsModal;
